<template>
  <AulaTemplate
    :titulo="$store.state.topicos[2].titulo"
    :numero="$store.state.topicos[2].numero"
    titleSize="5"
  >
    <TextBlock>
      <Paragraph>
        O Código de Trânsito Brasileiro (CTB) estabelece uma série de direitos e deveres para os motoristas, visando garantir a segurança e a fluidez no trânsito. Neste tópico, exploraremos a importância de conhecer e compreender esses direitos e deveres, fundamentais para uma condução responsável e segura.
Então, vamos lá?
      </Paragraph>
    </TextBlock>

    <v-row justify="center" class="mt-8">
      <v-col cols="12" lg="7">
        <Imagem src="topico_03/frase_balao_5.svg" />
      </v-col>
    </v-row>

    <TextBlock>
      <Paragraph>
        Vamos agora reforçar seus conhecimentos, revisitando os seus direitos e
        deveres no trânsito (BRASIL, 2009, p.13):
      </Paragraph>
    </TextBlock>

    <div ref="PitStopDoSaber_3">
      <PitStopDoSaber route="topico-3-atividade-1" />
    </div>

    <BoxIcon tipo="recapitulando">
      Chegamos ao final do Módulo 1. Esperamos que os conhecimentos adquiridos
      o(a) tornem um motorista mais consciente e responsável. Neste módulo,
      abordamos aspectos fundamentais da legislação de trânsito, oferecendo
      informações gerais que visam ampliar seu entendimento e aprimorar suas
      habilidades ao dirigir. Continue se dedicando para garantir um trânsito
      mais seguro e eficiente.
    </BoxIcon>
  </AulaTemplate>
</template>

<script>
import AulaTemplate from "@/components/AulaTemplate.vue";
import TextBlock from "@/components/TextBlock.vue";
import Paragraph from "@/components/Paragraph.vue";
import BoxIcon from "@/components/BoxIcon.vue";
import Imagem from "@/components/Imagem.vue";
import PitStopDoSaber from "@/components/PitStopDoSaber.vue";

export default {
  components: {
    AulaTemplate,
    TextBlock,
    Paragraph,
    BoxIcon,
    Imagem,
    PitStopDoSaber,
  },
  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    dialogInput(value) {
      if (!value) {
        // Acessa o player do vídeo através da referência ref
        const player = this.$refs.videoPlayer.player;

        if (player && typeof player.pauseVideo === "function") {
          player.pauseVideo();
        }
      }
    },

    goToPitStop_3() {
      let element = this.$refs["PitStopDoSaber_3"];
      let top = element.offsetTop - 60;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },
  },

  mounted() {
    this.$store.commit("ADICIONAR_SCORE", "topico_03");
    if (this.$route.query.goTo === "goToPitStop_3") {
      this.goToPitStop_3();
    }
  },
};
</script>

<style scoped></style>
